// @flow
import * as React from 'react';
import type { SvgComponentProps } from '~/core/icons/svg-icons/types';

const ArrowRightDouble = ({ fill, svgComponents: { G, Path } }: SvgComponentProps) => {
    const gProps = fill ? { fill } : {};
    return (
        <G {...gProps}>
            <Path d="M20.2551089,32.9199586 L33.0187453,19.9700003 L20.2551089,7.02004196 C19.5671845,6.32207538 19.5753253,5.1985888 20.2732919,4.51066444 C20.9712585,3.82274009 22.0947451,3.83088093 22.7826694,4.52884751 L38.0016574,19.9700003 L22.7826694,35.411153 C22.0947451,36.1091196 20.9712585,36.1172604 20.2732919,35.4293361 C19.5753253,34.7414117 19.5671845,33.6179252 20.2551089,32.9199586 Z M2.51066444,32.9199586 L15.2743009,19.9700003 L2.51066444,7.02004196 C1.82274009,6.32207538 1.83088093,5.1985888 2.52884751,4.51066444 C3.22681409,3.82274009 4.35030067,3.83088093 5.03822503,4.52884751 L20.257213,19.9700003 L5.03822503,35.411153 C4.35030067,36.1091196 3.22681409,36.1172604 2.52884751,35.4293361 C1.83088093,34.7414117 1.82274009,33.6179252 2.51066444,32.9199586 Z" />
        </G>
    );
};

export default ArrowRightDouble;



// WEBPACK FOOTER //
// ./src/core/icons/svg-icons/general/arrow-right-double/index.js